import React, { useRef, useState, useEffect } from "react";

import { ReactComponent as LeftDoubleArrow } from "../../assets/images/icons/leftArrowDouble.svg";
import { ReactComponent as RightDoubleArrow } from "../../assets/images/icons/rightArrowDouble.svg";

const GetMappedTabs = ({ headersMovedtoTop }) => {
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [activeTab, setActiveTab] = useState("ALL"); // track active tab

  const keys = headersMovedtoTop
    ? Array.from(headersMovedtoTop.getFacetedUniqueValues().keys()).filter((key) => key !== null)
    : [];

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    }
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [headersMovedtoTop]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 150;
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  if (!headersMovedtoTop) return <div />;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
    >
      {/* Left arrow */}
      {showLeft && (
        <div className="w-7 h-7 rounded-[5px] border border-gray-300 hover:bg-primary-hover flex items-center justify-center">
          <LeftDoubleArrow onClick={() => scroll("left")} className="cursor-pointer" />
        </div>
      )}

      {/* Tabs container */}
      <div
        ref={scrollRef}
        className="scrollable-tabs"
        style={{
          display: "flex",
          overflowX: "auto", // allow scrolling, we hide scrollbar via CSS only for this class
          gap: "8px",
          flex: 1,
          padding: "6px 18px", // leave space for arrows
        }}
      >
        <div
          onClick={() => {
            setActiveTab("ALL"); // mark "ALL" as active
            headersMovedtoTop.setFilterValue([]); // clear filter
          }}
          className={`cursor-pointer px-3 py-1 rounded-[20px] flex-shrink-0 whitespace-nowrap transition
      ${
        activeTab === "ALL"
          ? "text-secondary bg-primary" // active style
          : "bg-primary-hover text-primary-70 hover:bg-primary-active"
      }`}
        >
          All
        </div>
        {keys.map((item, index) => {
          let displayText = item;
          try {
            const parsed = JSON.parse(item);
            if (parsed?.value) displayText = parsed.value;
          } catch {}

          const isActive = activeTab === item;

          return (
            <div
              key={index}
              onClick={() => {
                setActiveTab(item); // set active tab
                headersMovedtoTop.setFilterValue([item]);
              }}
              className={`cursor-pointer px-3 py-1 rounded-[20px] flex-shrink-0 whitespace-nowrap transition
                ${
                  isActive
                    ? "text-secondary bg-primary" // active tab style
                    : "bg-primary-hover text-primary-70 hover:bg-primary-active"
                }`}
            >
              {displayText}
            </div>
          );
        })}
      </div>

      {/* Right arrow */}
      {showRight && (
        <div className="w-7 h-7 rounded-[5px] border border-gray-300 hover:bg-primary-hover flex items-center justify-center">
          <RightDoubleArrow onClick={() => scroll("right")} className="cursor-pointer" />
        </div>
      )}

      {/* Scoped CSS */}
      <style>{`
        .scrollable-tabs {
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE/Edge */
        }
        .scrollable-tabs::-webkit-scrollbar {
          display: none; /* Chrome, Safari */
        }
      `}</style>
    </div>
  );
};

export default GetMappedTabs;
